import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-162" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-163" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-164" data-mp="1mmqz075erpqa">
          Specjalna oferta startowa
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-165" data-mp="tzmpppza8p8p">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-166" data-mp="p1bhfjomymsl">
            Pakiet MUZYKA GOTOWA™
          </span>

          <dl data-id="element-167" data-mp="2fc68utlc7ckm">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-168" data-mp="2famuj8j8rblh">
                <dt className="text-ink/80" data-id="element-169" data-mp="pl0cxuyqtwee">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-170" data-mp="pmlc5xw063il">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-171" data-mp="zieuxz0bet8t">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-172" data-mp="13k01l2m9abak">
                Wartość całkowita:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-173" data-mp="6uiow3ouvozd">667 zł</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-174" data-mp="btvkpdxpg6e3">
            Tylko dziś
          </p>
          <p className="flex items-baseline justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-175" data-mp="fskvqzv9tbuk">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-176" data-mp="kmywziwm6d75">
              69 PLN
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-177" data-mp="3o9fo3lefzdue">
            Jednorazowa płatność, dożywotni dostęp. Bez subskrypcji.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-178" data-mp="qgxfnyklz1mr" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-179" data-mp="qg4inpbgbqht">
            Oferta ograniczona czasowo · Jednorazowa płatność · Dożywotni dostęp
          </p>
        </div>
      </div>
    </section>;
}